var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('indicadores-resumo-preditiva'),_c('hr'),_c('os-preditiva'),_c('reloadPage')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }